<template>
  <ProductCarousel
    v-if="products.length > 0"
    title="Shop a state of bliss"
    :header-link="{
      text: 'Shop all',
      link: '/collections/a-state-of-bliss',
    }"
    :products="products"
    :flat-lays="flatLays"
  />
</template>

<script>
import ProductCarousel from "@/components/ProductCarouselV2.vue";
import featuredCollectionQuery from "@/graphql/queries/FeaturedCollection.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { PER_PAGE, RelayConnection } from "@/helpers/pagination";

export default {
  name: "FeaturedCollectionCarouselV2",
  components: {
    ProductCarousel,
  },
  props: {
    collectionHandle: {
      type: String,
      required: true,
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collection: {
        products: new RelayConnection(),
      },
    };
  },
  computed: {
    products() {
      return unwrapNodes(this.collection.products?.edges);
    },
  },
  apollo: {
    collection: {
      query: featuredCollectionQuery,
      variables() {
        return {
          collection: this.collectionHandle,
          first: PER_PAGE,
        };
      },
    },
  },
};
</script>
